import { render, staticRenderFns } from "./PurchaseAndSaleTable.vue?vue&type=template&id=6690e8a6&scoped=true&"
import script from "./PurchaseAndSaleTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseAndSaleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6690e8a6",
  null
  
)

export default component.exports